import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAttendance, toggleAttendance, updateAttendance, AttendanceType, conjugateAttendanceStatus, currUserAttendanceStatus } from '@happenings/components/entities/attendance';
import { getSaves, toggleSave } from '@happenings/components/post';
import Store from '@happenings/components/store';
import { isUserAttendee, isUserLiker } from '../../reducers/selectors';
import CopyEventLink from './CopyEventLink';
import classNames from 'classnames';

type Props = {
  postId: number;
};

const InteractionButtons = ({ postId }: Props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state: Store) => state.session.currentUser);
  const post = useSelector((state: Store) => state.entities.posts[ postId ]);
  const isAttending = useSelector((state: Store) => isUserAttendee(state, postId));
  const userAttendance = useSelector((state: Store) => currUserAttendanceStatus(state, postId));
  const isSaved = useSelector((state: Store) => isUserLiker(state, postId));
  const [ showRSVPOptions, setShowRSVPOptions ] = React.useState(false);

  const [ rsvpSelection, setRSVPSelection ] = React.useState<AttendanceType>(AttendanceType.UNDEFINED);

  const startBtnText = isSaved ? 'Saved!' : 'Save';
  const attendBtnTxt = conjugateAttendanceStatus(rsvpSelection);

  React.useEffect(() => {
    setRSVPSelection(userAttendance);
  }
    , [ userAttendance ]);

  React.useEffect(() => {
    if (postId) {
      dispatch(getAttendance(postId));
      dispatch(getSaves(postId));
    }
  }, [ dispatch, postId ]);

  if (!currentUser) return null;

  const handleAttendanceChange = (newAttendance: AttendanceType) => {
    setRSVPSelection(newAttendance);
    dispatch(updateAttendance(postId, newAttendance));
    setShowRSVPOptions(false);
  };

  return (
    <div className="post-button-container">
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <CopyEventLink postId={postId} />
          <button
            className={classNames('post-btn item', { 'active': isSaved })}
            type="button"
            onClick={() => dispatch(toggleSave(postId, currentUser.id, isSaved))}
          >
            {startBtnText}
          </button>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '60px' }}>
            {post?.isPrivate ? (
              showRSVPOptions ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                  <button
                    className={classNames('post-btn item', { 'active': rsvpSelection === AttendanceType.GOING })}
                    type="button"
                    onClick={() => handleAttendanceChange(AttendanceType.GOING)}
                  >
                    Going
                  </button>
                  <button
                    className={classNames('post-btn item', { 'active': rsvpSelection === AttendanceType.MAYBE })}
                    type="button"
                    onClick={() => handleAttendanceChange(AttendanceType.MAYBE)}
                  >
                    Might go
                  </button>
                  <button
                    className={classNames('post-btn item', { 'active': rsvpSelection === AttendanceType.NOT_GOING })}
                    type="button"
                    onClick={() => handleAttendanceChange(AttendanceType.NOT_GOING)}
                  >
                    Can&apos;t go
                  </button>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <button
                    className={classNames('post-btn item', { 'active': isAttending !== AttendanceType.UNDEFINED })}
                    type="button"
                    onClick={() => setShowRSVPOptions(true)}
                  >
                    {attendBtnTxt}
                  </button>
                </div>
              )
            ) : (
              <button
                className={classNames('post-btn item', { 'active': isAttending === true })}
                type="button"
                onClick={() => dispatch(toggleAttendance(postId, currentUser.id, isAttending))}
              >
                {isAttending ? 'Going!' : 'Attend'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InteractionButtons;